import {Link, useLocation} from "react-router-dom";
import styles from './Icon.module.scss';
import useAnalyticsEventTracker from "../../tools/useAnalyticsEventTracker";

export default function Icon({title, description, imgUrl, link, externalLink}) {

  const gaEventTracker = useAnalyticsEventTracker()
  const location = useLocation()

  const clickExternalLink = (event) => {
    event.preventDefault()
    gaEventTracker('clickOut', location.pathname)
    window.location.href = event.currentTarget.href
  }

  return (
    <>
      <div className={styles.Icon}>
        {link &&
          <Link to={link} className={styles.IconLink}>
            <InnerIcon imgUrl={imgUrl} description={description} title={title}/>
          </Link>
        }
        {externalLink &&
          <a href={externalLink}  onClick={clickExternalLink} className={styles.IconLink}>
            <InnerIcon imgUrl={imgUrl} description={description} title={title}/>
          </a>
        }
      </div>
    </>
  );
}

function InnerIcon({title, description, imgUrl}) {

  const imageUrl = process.env.REACT_APP_BASE_URL === undefined ? imgUrl : `${process.env.REACT_APP_BASE_URL}${imgUrl}`

  return (
    <>
      <div className={styles.IconImage}>
        {imageUrl &&
          <img src={imageUrl} alt={""}/>
        }
        {!imageUrl &&
          <div className={styles.IconImagePlaceholder}></div>
        }
      </div>
      <div className={styles.IconText}>
        {title}
      </div>
      { description &&
        <div className={styles.IconDescription}>
          {description}
        </div>
      }
    </>
  );
}